export const DEPARTMENT = 'DEPART';
export const PROJECT = 'PROJET';